export default __webpack_public_path__ + "static/media/best_submit_form_project-6.4bfe0d08.png";